import React, { useEffect } from "react";
import { X, ChevronLeft, ChevronRight } from "lucide-react";

export default function Lightbox({ images, currentIndex, onClose, onPrev, onNext }) {
  useEffect(() => {
    if (currentIndex === null || !images || images.length === 0) return undefined;

    const handleKeyDown = (e) => {
      if (e.key === "Escape") onClose();
      if (e.key === "ArrowLeft") onPrev();
      if (e.key === "ArrowRight") onNext();
    };

    const previousOverflow = document.body.style.overflow;
    window.addEventListener("keydown", handleKeyDown);
    document.body.style.overflow = "hidden";

    return () => {
      window.removeEventListener("keydown", handleKeyDown);
      document.body.style.overflow = previousOverflow;
    };
  }, [currentIndex, images, onClose, onPrev, onNext]);

  if (currentIndex === null || !images || images.length === 0) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-primary-950/95 backdrop-blur-sm transition-opacity duration-300">
      {/* Close button */}
      <button
        onClick={onClose}
        className="absolute top-6 right-6 z-50 rounded-full bg-primary-900/50 p-3 text-primary-100 hover:bg-brand-600 hover:text-white transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-brand-500"
        aria-label="Luk galleri"
      >
        <X className="h-6 w-6" />
      </button>

      {/* Navigation buttons */}
      {images.length > 1 && (
        <>
          <button
            onClick={onPrev}
            className="absolute left-4 md:left-8 z-50 rounded-full bg-primary-900/50 p-3 text-primary-100 hover:bg-brand-600 hover:text-white transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-brand-500"
            aria-label="Forrige billede"
          >
            <ChevronLeft className="h-6 w-6" />
          </button>
          <button
            onClick={onNext}
            className="absolute right-4 md:right-8 z-50 rounded-full bg-primary-900/50 p-3 text-primary-100 hover:bg-brand-600 hover:text-white transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-brand-500"
            aria-label="Næste billede"
          >
            <ChevronRight className="h-6 w-6" />
          </button>
        </>
      )}

      {/* Image container */}
      <div className="relative max-h-[85vh] max-w-[90vw] md:max-w-[80vw] flex flex-col items-center justify-center select-none">
        <img
          src={images[currentIndex]}
          alt={`Galleri billede ${currentIndex + 1}`}
          className="max-h-[80vh] max-w-full object-contain rounded-lg shadow-2xl border border-primary-800"
        />
        <div className="mt-4 text-center text-primary-300 text-sm font-medium">
          Billede {currentIndex + 1} af {images.length}
        </div>
      </div>
    </div>
  );
}
